import { render, staticRenderFns } from "./preferences.form.vue?vue&type=template&id=58e024f7&scoped=true&"
import script from "./preferences.form.vue?vue&type=script&lang=js&"
export * from "./preferences.form.vue?vue&type=script&lang=js&"
import style0 from "./preferences.form.vue?vue&type=style&index=0&id=58e024f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e024f7",
  null
  
)

export default component.exports